import {ScrollTrigger} from "../LibrariesImport";

export default class AppearOnScroll {

	static init() {
		const items = document.querySelectorAll('[data-aos]');
		items.forEach((item) => {
			ScrollTrigger.create({
				trigger: item,
				start: 'top 90%',
				once: true,
				toggleClass: "appeared"
			});
		});
	}
}
